import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import BillingInfo from "module/main/components/BillingInfo/BillingInfo";
// utils
var AddPaymentMethod = function () {
    var navigate = useNavigate();
    return (_jsx("div", { className: "px-40 py-5", children: _jsx(BillingInfo, { submitButtonText: "Use This Payment Method", onSubmitCallback: function () { return Promise.resolve(navigate("/")); } }) }));
};
export default AddPaymentMethod;
